import {hapticTypes} from "./hapticTypes";

export function triggerHaptic(type: keyof typeof hapticTypes) {
    if ("vibrate" in navigator) {
        navigator.vibrate(hapticTypes[type] as number);
    }
}
